import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  Input,
  Layout,
  Row,
  Select,
  Table,
  TableProps,
  TreeSelect
} from "antd";
import { ColumnsType } from "antd/es/table";
import { get, toNumber } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import ActionContent from "src/components/common/ActionContent";
import FilterAction from "src/components/common/FilterAction";
import ModalDeleteConfirm from "src/components/common/ModalDeleteConfirm";
import { apiCaller, cancelListToken } from "src/util/apiCaller";
import {
  getLocalStorage,
  reDataForTable,
  setLocalStorage,
  StringValueReturn
} from "src/util/Commom";
import { MessageStatusError } from "src/util/MessageStatus";

const FormItem = Form.Item;

const NguoiDung = ({ status }: any) => {
  const { isActive } = status;
  const [isLoadTable, setIsLoadTable] = useState<boolean>(false);
  const [datatable, setDatatable] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const pageSize = 10;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [keyword, setKeyword] = useState("");
  const [idPhongBan, setIdPhongBan] = useState("");
  const [treeDataPB, setTreeDataPB] = useState();
  const [isLoadingPhongBan, setIsLoadPhongBan] = useState(false);
  const [listVaiTro, setListVaiTro] = useState<any[]>([]);
  const [isLoadingVaiTro, setIsLoadingVaiTro] = useState(false);
  const [idVaiTro, setIdVaiTro] = useState("");
  const [isSearchClick, setIsSearchClick] = useState(false);

  const { resetFields, setFieldsValue } = form;

  useEffect(() => {
    if (isActive) {
      const state = getLocalStorage("dataFilter") || undefined;
      if (state) {
        const idPhongBan = state.idPhongBan || undefined;
        const idVaiTro = state.idVaiTro || undefined;
        setFieldsValue({ keyword: state.keyword });
        setFieldsValue({ idPhongBan: idPhongBan });
        setFieldsValue({ idVaiTro: idVaiTro });
        setKeyword(state.keyword);
        setActivePage(state.activePage);
        setIdPhongBan(idPhongBan);
        setIdVaiTro(idVaiTro);
        getListData(state.keyword, idPhongBan, idVaiTro, state.activePage);
      } else {
        getListData(keyword, idPhongBan, idVaiTro, activePage);
      }
      getListPhongBan();
      getListDataVaiTro();
    } else {
      navigate("/error/401");
    }
    return () => {
      cancelListToken(["listVaiTro", "listNguoiDung", "listPhongBan"]);
    };
  }, []);

  /**
   * getListDataVaiTro : get danh sách vai trò
   * @memberof NguoiDung
   */
  const getListDataVaiTro = async () => {
    setIsLoadingVaiTro(true);
    const configAPI = {
      url: `api/vaitros`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listVaiTro"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        setListVaiTro(get(response.data, "content", []));
        setIsLoadingVaiTro(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadingVaiTro(false);
      }
    } catch (err) {
      setIsLoadingVaiTro(false);
      err;
    }
  };

  /**
   * getListData : get danh sách người dùng
   * @param {number} activePage
   * @param {number} idPhongBan
   * @param {string} keyword
   * @param {number} idVaiTro
   * @memberof NguoiDung
   */
  const getListData = async (
    keyword: string,
    idPhongBan: any,
    idVaiTro: any,
    activePage: number
  ) => {
    setIsLoadTable(true);
    const configAPI = {
      url: `api/nguoidungs?keyword=${keyword}&idphongban=${
        idPhongBan || ""
      }&idvaitro=${idVaiTro || ""}&page=${activePage}&size=${pageSize}`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listNguoiDung"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = reDataForTable(
          get(response.data, "content", []),
          activePage,
          pageSize
        );
        setDatatable(data as any);
        setTotal(get(response.data, "totalElements", 0));
        setIsLoadTable(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadTable(false);
      }
    } finally {
      setIsLoadTable(false);
    }
  };

  /**
   * getListPhongBan : get danh sách phòng ban
   * @memberof NguoiDung
   */
  const getListPhongBan = async () => {
    setIsLoadPhongBan(true);
    const configAPI = {
      url: `api/phongbans/gettreealluser`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listPhongBan"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = get(response, "data", []);
        setTreeDataPB(data);
        setIsLoadPhongBan(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadPhongBan(false);
      }
    } finally {
      setIsLoadPhongBan(false);
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      width: "5%",
      align: "center",
      render: (e) => <span>{e}</span>
    },
    { title: "Họ và tên", dataIndex: "hoVaTen", key: "hoVaTen" },
    { title: "Tài khoản", dataIndex: "userName", key: "userName" },
    {
      title: "Tên đơn vị",
      dataIndex: "",
      key: "phongBan.tenDonVi",
      render: (item) => renderPhongBan(item)
    },
    {
      title: "Vai trò",
      dataIndex: "",
      key: "vaiTros",
      render: (item) => (
        <StringValueReturn
          fieldName="tenVaiTro"
          text="Vai trò"
          type="array"
          value={item.vaiTros}
        />
      )
    },
    {
      title: "Hành động",
      dataIndex: "",
      key: "x",
      align: "center",
      width: "10%",
      render: (item) => actionContent(item)
    }
  ];

  /**
   * treeDataSelect: Vòng lặp tìm treeData
   * @memberof NguoiDung
   */
  const treeDataSelect = useMemo(() => {
    const loop = (data: any) =>
      data?.map((item: any) => {
        if (item.children) {
          return {
            title: item.tenDonVi,
            value: item.id,
            key: item.id,
            children: loop(item.children)
          };
        }
        return {
          title: item.tenDonVi,
          value: item.id,
          key: item.id
        };
      });
    return loop(treeDataPB);
  }, [treeDataPB]);

  /**
   * renderPhongBan: Hiển thị tên phòng ban và tên đơn vị
   * @param {object} item
   * @memberof NguoiDung
   */
  const renderPhongBan = (item: any) => {
    const {
      phongBan: { tenDonVi: tenPhongBan }
    } = item;
    const tenDonViParent = item.tenDonViParent || "";
    let donViPhongBan = null;
    if (tenPhongBan === tenDonViParent)
      donViPhongBan = tenPhongBan;
    else
      donViPhongBan = <span>{tenPhongBan} <br /><i>{tenDonViParent && '(' + tenDonViParent + ')'}</i></span>;
    return (
      <>
        {donViPhongBan}
      </>
    );
  };

  /**
   * actionContent: Hành động trên bảng
   * @param {object} item
   * @memberof NguoiDung
   */
  const actionContent = (item: object) => {
    return (
      <ActionContent
        onDeleteItem={() => deleteItemFunc(item)}
        onEditItem={() => handleRedirect("edit", item)}
      />
    );
  };

  /**
   * deleteItemFunc: Xoá item theo item
   * @param {object} item
   * @memberof Quyen
   */
  const deleteItemFunc = (item: object) => {
    ModalDeleteConfirm(deleteItemAction, item);
  };

  /**
   * deleteItemAction: Xóa item
   * @param {object} item
   * @memberof Quyen
   */
  const deleteItemAction = async (item: any) => {
    const config = {
      url: `api/nguoidungs/${item.id}`,
      apiType: "DELETE",
      value: null,
      method: "DELETE",
      getName: "deleteNguoiDung"
    };
    const response = await apiCaller(config);
    try {
      if (response?.status === 200 || response?.status === 201) {
        const dataPage = total - (activePage - 1) * pageSize;
        const page = dataPage <= 1 && total !== 1 ? activePage - 1 : activePage;
        getListData(keyword, idPhongBan, idVaiTro, page);
        setIsLoadTable(true);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadTable(false);
      }
    } catch (error) {
      setIsLoadTable(false);
      // Xử lý lỗi khi lưu dữ liệu không thành công
    }
  };

  /**
   * handleRedirect: Chuyển trang thêm mới và chỉnh sửa
   * @param {string} type
   * @param {object} item
   * @memberof NguoiDung
   */
  const handleRedirect = (type = "", item: any) => {
    let pathname = "/quan-tri/nguoi-dung";
    switch (type) {
      case "new":
        pathname += "/them-moi/";
        break;
      case "edit":
        pathname += `/${item.id}/chinh-sua/`;
        break;
      default:
        break;
    }
    navigate(pathname, { state: { itemData: item } });
    if (isSearchClick) {
      const content = {
        activePage,
        pageSize,
        idPhongBan,
        idVaiTro,
        keyword,
        pathname: "quan-tri/nguoi-dung"
      };
      setLocalStorage("dataFilter", content);
    }
  };

  /**
   * handleTableChange
   * Fetch dữ liệu dựa theo thay đổi trang
   * @param {object} pagination
   * @memberof NguoiDung
   */
  const handleTableChange: TableProps["onChange"] = (pagination) => {
    const activePage = pagination.current as number;
    getListData(keyword, idPhongBan, idVaiTro, activePage);
    setActivePage(activePage);
  };

  /**
   * onChangeDonVi: Chọn đơn vị/ phòng ban
   * @param {number} e
   * @memberof NguoiDung
   */
  const onChangeDonVi = (e: any) => {
    setIdPhongBan(e);
  };

  /**
   * onChangeDonVi: Chọn vai trò
   * @param {number} e
   * @memberof NguoiDung
   */
  const onChangeVaiTro = (e: any) => {
    setIdVaiTro(e);
  };

  /**
   * onChangeText: Thay đổi keyword tìm kiếm
   * @param {object} e
   * @memberof NguoiDung
   */
  const onChangeText = (e: any) => {
    const keyword = e.target.value;
    setKeyword(keyword);
  };

  /**
   * handleSubmit: Thực hiện hành động tìm kiếm
   * @memberof NguoiDung
   */
  const handleSubmit = () => {
    setIsSearchClick(true);
    getListData(keyword, idPhongBan, idVaiTro, activePage);
  };

  /**
   * handleSubmit: Thực hiện hành động làm mới
   * @memberof NguoiDung
   */
  const handleReset = () => {
    setFieldsValue({ idPhongBan: "", idVaiTro: "" });
    setIdPhongBan("");
    setIdVaiTro("");
    setKeyword("");
    setTimeout(() => {
      resetFields();
    }, 0);
    localStorage.removeItem("dataFilter");
  };

  /**
   * expandedRowRender: Mở rộng trên table
   * @param {object} item
   * @memberof NguoiDung
   */
  const expandedRowRender = (item: any) => {
    if (item) {
      return (
        <Row gutter={18}>
          <StringValueReturn
            text="Giới tính"
            type="gender"
            value={item.gioiTinh}
          />
          <StringValueReturn
            fieldName="tenDonVi"
            text="Phòng ban"
            value={item.phongBan}
          />
          <StringValueReturn
            fieldName="diaChi"
            text="Địa chỉ"
            type="text"
            value={item.diaChi}
          />
          <StringValueReturn
            fieldName="dienThoai"
            text="Số điện thoại"
            type="text"
            value={item.dienThoai}
          />
          <StringValueReturn
            fieldName="maDinhDanh"
            text="Mã đinh danh đơn vị"
            type="text"
            value={item.phongBan.maDinhDanh}
          />
          <StringValueReturn
            fieldName="tenVaiTro"
            text="Vai trò"
            type="array"
            value={item.vaiTros}
          />
          <StringValueReturn
            fieldName="tenChucVu"
            text="Chức vụ"
            type="array"
            value={item.chucVus}
          />
          <StringValueReturn
            fieldName="tenNhomTuLieu"
            text="Nhóm tài liệu"
            type="array"
            value={item.nhomTuLieus}
          />
        </Row>
      );
    }
  };

  return (
    <Layout>
      <Flex justify="space-between" align="center">
        <h3 style={{ color: "black", fontSize: 20 }}>Người dùng</h3>
        <Button
          className="heading-button-addnew btn"
          type="primary"
          onClick={() => handleRedirect("new", null)}
          icon={<PlusOutlined />}
        >
          Thêm mới
        </Button>
      </Flex>
      <Card className="th-card-margin-bottom">
        <Form layout="vertical" form={form} name="quyen-control">
          <Col>
            <Row gutter={16} style={{ marginTop: -2 }}>
              <Col md={8} xs={24}>
                <FormItem
                  className="ant-input-group"
                  label="Nhập từ khóa"
                  name="keyword"
                >
                  <Input
                    placeholder="Nhập từ khóa..."
                    onChange={onChangeText}
                    onPressEnter={handleSubmit}
                    style={{ width: "100%" }}
                  />
                </FormItem>
              </Col>
              <Col md={8} xs={24}>
                <FormItem
                  className="ant-input-group"
                  label="Phòng ban"
                  name="idPhongBan"
                  initialValue={idPhongBan || undefined}
                >
                  <TreeSelect
                    showSearch
                    placeholder="Vui lòng chọn đơn vị/phòng ban"
                    onChange={onChangeDonVi}
                    loading={isLoadingPhongBan}
                    treeData={treeDataSelect}
                    treeNodeFilterProp="title"
                    style={{ width: "100%" }}
                    dropdownStyle={{ overflow: "auto" }}
                  />
                </FormItem>
              </Col>
              <Col md={8} xs={24}>
                <FormItem
                  className="ant-input-group"
                  label="Vai trò"
                  name="idVaiTro"
                  initialValue={idVaiTro || undefined}
                >
                  <Select
                    allowClear
                    showSearch
                    onChange={onChangeVaiTro}
                    placeholder="Chọn vai trò"
                    style={{ width: "100%" }}
                    loading={isLoadingVaiTro}
                    options={listVaiTro}
                    optionFilterProp="tenVaiTro"
                    filterOption={(input, option: any) =>
                      (option?.tenVaiTro ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    fieldNames={{ label: "tenVaiTro", value: "id" }}
                  />
                </FormItem>
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col>
                <FilterAction search={handleSubmit} reset={handleReset} />
              </Col>
            </Row>
          </Col>
        </Form>
      </Card>
      <Card style={{ marginTop: "15px" }}>
        <Table
          rowKey={"id"}
          expandable={{
            expandedRowRender,
            expandRowByClick: true
          }}
          bordered
          columns={columns}
          className="qti-table-wrapper gx-table-responsive"
          dataSource={datatable}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "qti-table-row-background" : ""
          }
          size="middle"
          pagination={{
            current: activePage,
            pageSize,
            total,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: (total) =>
              pageSize <= total
                ? `Hiển thị ${pageSize} trong tổng ${total}`
                : `Tổng ${total}`
          }}
          loading={isLoadTable}
          onChange={handleTableChange}
          scroll={{ x: 1000 }}
          />
      </Card>
    </Layout>
  );
};
export default NguoiDung;
